import styled, { keyframes } from 'styled-components';
import { colors } from '@checkatrade/web-ui/themes';
import spacing from '@toolshed/styleguide/styles/spacing';
import { semibold, regular } from '@toolshed/styleguide/styles/typography';
import tabletPortrait from '@styles/breakpoint/tablet-portrait';
import { spacing1, spacing2, spacing4, spacing5 } from 'lib/mortar';

export const Wrapper = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  min-height: 60px;
  height: 60px;
  width: 100%;
  background-color: ${colors.neutral[0]};
  z-index: 103;
`;

const slideInLeft = keyframes`
  from {
    transform: translate3d(-100%, 0, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;

// animation to slide out the home page to the left
const slideOutLeft = keyframes`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(-100%, 0, 0);
  }
`;

export const Wing = styled.div<StyledDiv>`
  position: fixed;
  top: ${spacing.nav}px;
  left: 0;
  right: 0;
  z-index: 102;
  width: 100vw;
  background-color: ${colors.neutral[0]};
  bottom: 0;
  visibility: hidden;
  transform: translate3d(-100%, 0, 0);
  &.wing-enter-done,
  &.wing-exit {
    visibility: visible;
    transform: translate3d(0, 0, 0);
  }
  &.wing-enter {
    animation: ${slideInLeft} 0.2s forwards;
  }
  &.wing-exit {
    animation: ${slideOutLeft} 0.2s forwards;
  }
`;

export const LinkWrapper = styled.div<StyledDiv>`
  display: flex;
  align-items: center;
  margin: 0;
  height: 100%;
  cursor: pointer;
  position: relative;
`;

export const MegaWrapper = styled.div<StyledDiv>`
  position: relative;
  height: 100%;
  width: 100%;
  flex: 1;
  overflow: auto;
  border-top: 1px solid ${colors.border.main};
  background-color: ${colors.neutral[0]};
  display: flex;
  flex-direction: row;

  box-sizing: border-box;
`;

export const MegaInner = styled.nav`
  display: flex;
  flex-direction: row;
  padding: ${spacing.xxlarge}px 0px;
  ${tabletPortrait(`
    max-width: 1050px;
    margin: 0 auto;

  `)}
`;
export const MegaSection = styled.div<StyledDiv>`
  margin: ${spacing2};
  margin-right: ${spacing.xlarge}px;
  padding-right: ${spacing.xlarge}px;
  width: calc(100% - ${spacing4});
  border-right: 1px solid ${colors.secondary.DEFAULT};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  ${tabletPortrait(`
    &:first-child {
      margin-left: ${spacing2};
      width: calc(100% - ${spacing.xlarge + spacing2});
    }
    &:last-child {
      border-right: none;
      margin-right: ${spacing2};
      padding-right: 0;
      width: calc(100% - ${spacing.xlarge + spacing2});
    }
  `)};
  &:last-child {
    border-right: none;
    padding-right: 0;
  }
`;

export const MegaHighlight = styled.div<StyledDiv>`
  ${semibold('smedium')};
  background-color: ${colors.secondary.DEFAULT};
  color: ${colors.neutral[0]};
  margin-bottom: ${spacing2};
  padding: ${spacing1};
  padding-right: 30px;
  clip-path: polygon(0% 0%, 100% 0%, 90% 100%, 0% 100%);
  display: flex;
  ${tabletPortrait(semibold('smedium'))};
`;

export const MegaHeading = styled.div<StyledDiv>`
  ${semibold('smedium')};
  color: ${colors.secondary.DEFAULT};
  padding: ${spacing1} 0;
  margin-bottom: ${spacing2};
`;

export const MegaParagraph = styled.p<StyledParagraph>`
  ${regular('small')};
  flex: 1;
  color: ${colors.neutral[800]};
  margin: 0;
  margin-bottom: ${spacing5};
  max-width: 100%;
`;

export const SavedTradesWrapper = styled.div<StyledDiv>`
  ${regular('small')};
  display: flex;
  flex: 1;
`;
